import type { FC } from "react"
import React, { useMemo, useEffect, useRef } from "react"

import { useRecoilValue, useSetRecoilState } from "recoil"

import {
  centerOfImageState,
  findComputedImageState,
} from "../../state/imageElements"

const Image_Internal: FC<{ id: string }> = ({ id }) => {
  const image = useRecoilValue(findComputedImageState(id))
  const setCenterOfImage = useSetRecoilState(centerOfImageState)
  // why would we need this?
  // const selection = useRecoilValue(nodeSelectionState)
  const nodeRef = useRef(null)
  // const isSelected = selection.has(id)

  const { x, y, h, w, isLocked } = image

  const imageCenter = useMemo(
    () => ({ x: x + w / 2, y: y + h / 2 }),
    [x, y, h, w],
  )

  useEffect(() => {
    setCenterOfImage(imageCenter)
  }, [imageCenter, setCenterOfImage])

  return (
    <g ref={nodeRef}>
      <image
        href={image?.filename || ``}
        x={x}
        y={y}
        width={w}
        height={h}
        opacity={isLocked ? 0.7 : 1}
      />
    </g>
  )
}

export const Image = React.memo(Image_Internal)

export default Image
